import React from 'react';
export const FailureEstimationNotice = ({
  problemError,
  councelDirective,
}: {
  problemError: string;
  councelDirective: string;
}) => {
  return (
    <div className="flex flex-col items-center p-30">
      <span className="text-center text-sienna">{problemError}</span>
      <span className="text-center font-sans">{councelDirective}</span>
    </div>
  );
};
